// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import styled from 'styled-components';
import RouterLink from 'next/link';

export const Ad = styled.section`
  max-width: 1240px;
  margin: 0 auto;
  padding: 24px 20px 48px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.desktop} {
    padding: 24px 32px 64px;
  }
`;

export const Eyebrow = styled.p`
  margin: 0 0 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.inkMuted};
`;

export const Link = styled(RouterLink)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 24px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 14px;
  background: linear-gradient(93deg, rgba(244, 104, 0, 0.06) 0%, rgba(255, 136, 51, 0.12) 100%);
  text-decoration: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  p {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.ink};
  }

  &::after {
    content: '→';
    font-size: 18px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.grafanaOrange};
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.grafanaOrange};
    box-shadow: 0 6px 18px rgba(244, 104, 0, 0.12);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.grafanaOrange};
    outline-offset: 2px;
  }
`;
